import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import SalesInquiries from "@/pages/SalesInquiries";
export const Route = createFileRoute("/sales-inquiries")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><SalesInquiries /></ProtectedRoute>) });
